export default "__VITE_PUBLIC_ASSET__518ba8ec__"